// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `mat-dialog-content {
  min-width: 360px;
  padding: 2px 24px !important;
  background-color: #f0f0f0;
}

.content {
  padding: 16px;
  border-radius: 4px;
}

.dialog-content--warning {
  box-sizing: border-box;
  min-width: min(440px, calc(100vw - 48px));
  padding: 6px 20px 16px !important;
  background: #fff;
}

.dialog-heading {
  align-items: center;
  border-bottom: 1px solid #dee2e6;
  display: flex;
  gap: 14px;
  padding: 22px 24px 16px;
}

.dialog-heading__icon { align-items: center; background: #fff4df; border-radius: 50%; color: #a85b00; display: inline-flex; height: 38px; justify-content: center; width: 38px; }
.dialog-heading__eyebrow { color: #6c757d; display: block; font-size: .7rem; font-weight: 700; letter-spacing: .08em; text-transform: uppercase; }
.dialog-heading h2 { color: #212529; font-size: 1.25rem; line-height: 1.2; margin: 0; padding: 0; }
.dialog-heading--warning { border-top: 4px solid #d98200; gap: 12px; padding: 12px 20px; }
.dialog-heading--warning h2 { background: transparent; }
.dialog-heading--warning h2::before { display: none; }
.confirm-message {
  color: #333;
  font-size: 0.95rem;
  margin: 0;
}
.dialog-content--warning .confirm-message { color: #495057; line-height: 1.5; }
.dialog-details { border: 1px solid #dee2e6; margin-top: 12px; }
.dialog-detail { align-items: center; background: #fff; display: flex; gap: 20px; justify-content: space-between; padding: 9px 13px; }
.dialog-detail + .dialog-detail { border-top: 1px solid #dee2e6; }
.dialog-detail span { color: #495057; }
.dialog-detail strong { color: #a14300; text-align: right; }

mat-dialog-actions {
  background-color: #f0f0f0;
  padding: 8px 24px !important;
}
.dialog-actions--warning {
  background: #f8f9fa;
  border-top: 1px solid #dee2e6;
  padding: 12px 20px !important;
}

.button-gap {
  gap: 12px;
}

.btn-confirm {
  background-color: #0b2d71;
  color: #fff;
  border: none;
}

.btn-confirm:hover {
  background-color: #0a2560;
  color: #fff;
}

.dialog-actions--warning .btn-cancel { background: #fff; border: 1px solid #6c757d; color: #495057; }
.dialog-actions--warning .btn-cancel:hover { background: #e9ecef; color: #212529; }

@media (max-width: 520px) {
  .dialog-content--warning { min-width: 0; }
  .dialog-detail { align-items: flex-start; flex-direction: column; gap: 3px; }
  .dialog-actions--warning { flex-wrap: wrap; }
}

`, "",{"version":3,"sources":["webpack://./projects/cemsys/src/app/shared/confirm-dialog/confirm-dialog.component.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,yCAAyC;EACzC,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA,wBAAwB,mBAAmB,EAAE,mBAAmB,EAAE,kBAAkB,EAAE,cAAc,EAAE,oBAAoB,EAAE,YAAY,EAAE,uBAAuB,EAAE,WAAW,EAAE;AAChL,2BAA2B,cAAc,EAAE,cAAc,EAAE,gBAAgB,EAAE,gBAAgB,EAAE,qBAAqB,EAAE,yBAAyB,EAAE;AACjJ,qBAAqB,cAAc,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,SAAS,EAAE,UAAU,EAAE;AAClG,2BAA2B,6BAA6B,EAAE,SAAS,EAAE,kBAAkB,EAAE;AACzF,8BAA8B,uBAAuB,EAAE;AACvD,sCAAsC,aAAa,EAAE;AACrD;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;AACX;AACA,4CAA4C,cAAc,EAAE,gBAAgB,EAAE;AAC9E,kBAAkB,yBAAyB,EAAE,gBAAgB,EAAE;AAC/D,iBAAiB,mBAAmB,EAAE,gBAAgB,EAAE,aAAa,EAAE,SAAS,EAAE,8BAA8B,EAAE,iBAAiB,EAAE;AACrI,kCAAkC,6BAA6B,EAAE;AACjE,sBAAsB,cAAc,EAAE;AACtC,wBAAwB,cAAc,EAAE,iBAAiB,EAAE;;AAE3D;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,6BAA6B;AAC/B;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA,uCAAuC,gBAAgB,EAAE,yBAAyB,EAAE,cAAc,EAAE;AACpG,6CAA6C,mBAAmB,EAAE,cAAc,EAAE;;AAElF;EACE,2BAA2B,YAAY,EAAE;EACzC,iBAAiB,uBAAuB,EAAE,sBAAsB,EAAE,QAAQ,EAAE;EAC5E,2BAA2B,eAAe,EAAE;AAC9C","sourcesContent":["mat-dialog-content {\n  min-width: 360px;\n  padding: 2px 24px !important;\n  background-color: #f0f0f0;\n}\n\n.content {\n  padding: 16px;\n  border-radius: 4px;\n}\n\n.dialog-content--warning {\n  box-sizing: border-box;\n  min-width: min(440px, calc(100vw - 48px));\n  padding: 6px 20px 16px !important;\n  background: #fff;\n}\n\n.dialog-heading {\n  align-items: center;\n  border-bottom: 1px solid #dee2e6;\n  display: flex;\n  gap: 14px;\n  padding: 22px 24px 16px;\n}\n\n.dialog-heading__icon { align-items: center; background: #fff4df; border-radius: 50%; color: #a85b00; display: inline-flex; height: 38px; justify-content: center; width: 38px; }\n.dialog-heading__eyebrow { color: #6c757d; display: block; font-size: .7rem; font-weight: 700; letter-spacing: .08em; text-transform: uppercase; }\n.dialog-heading h2 { color: #212529; font-size: 1.25rem; line-height: 1.2; margin: 0; padding: 0; }\n.dialog-heading--warning { border-top: 4px solid #d98200; gap: 12px; padding: 12px 20px; }\n.dialog-heading--warning h2 { background: transparent; }\n.dialog-heading--warning h2::before { display: none; }\n.confirm-message {\n  color: #333;\n  font-size: 0.95rem;\n  margin: 0;\n}\n.dialog-content--warning .confirm-message { color: #495057; line-height: 1.5; }\n.dialog-details { border: 1px solid #dee2e6; margin-top: 12px; }\n.dialog-detail { align-items: center; background: #fff; display: flex; gap: 20px; justify-content: space-between; padding: 9px 13px; }\n.dialog-detail + .dialog-detail { border-top: 1px solid #dee2e6; }\n.dialog-detail span { color: #495057; }\n.dialog-detail strong { color: #a14300; text-align: right; }\n\nmat-dialog-actions {\n  background-color: #f0f0f0;\n  padding: 8px 24px !important;\n}\n.dialog-actions--warning {\n  background: #f8f9fa;\n  border-top: 1px solid #dee2e6;\n  padding: 12px 20px !important;\n}\n\n.button-gap {\n  gap: 12px;\n}\n\n.btn-confirm {\n  background-color: #0b2d71;\n  color: #fff;\n  border: none;\n}\n\n.btn-confirm:hover {\n  background-color: #0a2560;\n  color: #fff;\n}\n\n.dialog-actions--warning .btn-cancel { background: #fff; border: 1px solid #6c757d; color: #495057; }\n.dialog-actions--warning .btn-cancel:hover { background: #e9ecef; color: #212529; }\n\n@media (max-width: 520px) {\n  .dialog-content--warning { min-width: 0; }\n  .dialog-detail { align-items: flex-start; flex-direction: column; gap: 3px; }\n  .dialog-actions--warning { flex-wrap: wrap; }\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
